









































import {Component, Prop, Vue, Watch} from "vue-property-decorator";

@Component
export default class EquipmentCard  extends Vue {

    @Prop({required: false, type: [Object, String], default: ''})
    public rules!:        { [x: string]: any} | undefined;

    @Prop({})
    public value!: any;

    // START --- All the Props from v-text-field to make using the component easier

    @Prop({ type: Number, default: 5})
    public rows!: number;

    @Prop({ type: String})
    public appendOuterIcon!: string;

    @Prop({ type: Boolean})
    public autofocus!: boolean;

    @Prop({ type: Boolean})
    public clearable!: boolean;

    @Prop({ type: String, default: '$clear'})
    public clearIcon!: string;

    @Prop({ type: [Boolean, Number, String]})
    public counter!: any;

    // counterValue: Function as PropType<(value: any) => number>,

    @Prop({ type: Boolean})
    public filled!: any;
    @Prop({ type: Boolean})
    public flat!: any;
    @Prop({ type: Boolean})
    public fullWidth!: boolean;



    @Prop({ type: String})
    public label!: string;

    @Prop({ type: Boolean})
    public outlined!: any;

    @Prop({ type: String})
    public placeholder!: string;
    @Prop({ type: String})
    public prefix!: string;
    @Prop({ type: String})
    public prependInnerIcon!: string;

    @Prop({ type: Boolean})
    public reverse!: boolean;

    @Prop({ type: Boolean})
    public rounded!: boolean;

    @Prop({ type: Boolean})
    public shaped!: boolean;

    @Prop({ type: Boolean})
    public singleLine!: boolean;


    @Prop({ type: Boolean})
    public solo!: boolean;

    @Prop({ type: Boolean})
    public soloInverted!: boolean;

    @Prop({ type: String})
    public suffix!: string;

    @Prop({ type: String, default: 'text'})
    public type!: string;


    // END --- All the Props from v-text-field to make using the component easier
    private innerValue = '';

    @Watch('innerValue')
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onInnerValueChanged(newVal: string, oldVal: string) {
        this.$emit("input", newVal);
    }

    @Watch('value')
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onValueChanged(newVal: string, oldVal: string) {
        this.innerValue = newVal;
    }


    created() {
        if (this.value) {
            this.innerValue = this.value;
        }
    }
}
